import React, { useState } from "react";

import Table from "components/Table";
import Filter from "@Components/Filter";
import { IconButton } from "@material-ui/core";
import ExcelLogo from "assets/img/excelred_icon.svg";
import FileDownload from "components/FormikControl/FileDownload";
import eightAxios from "../../configs/axiosConfig";
import { useNotifyContext } from "@Components/Notify";
import {

  BANNER_URL,

} from "configs/constants";


let model = [
  { id: "display_start_datetime", label: "Display Start Date Time", type: "datetime" },
  { id: "title", label: "Title", type: "string" },
  { id: "banner_type", label: "Type", type: "string" },
  {
    id: "is_active",
    label: "Active",
    type: "boolean",
    yesValue: "Active",
    noValue: "Inactive",
  },
];
const isBannerDelete = true;




const filterFields = [
  {
    type: "reactselect",
    label: "Banner Type",
    name: "banner_type",
    outerOptions: [{ id: "IAB", name: "In-app Banner" },{ id: "PB", name: "Policy Banner" }],
    
  },
  {
    type: "reactselect",
    label: "Is Active",
    name: "is_active",
    outerOptions: [
      { id: "1", name: "Active" },
      { id: "0", name: "Inactive" },
    ],
  },
  {
    type: "datepicker",
    label: "Display Start Date",
    name: "display_start_date",
  },
];

const filterInitialValues = {
  banner_type: "",
  is_active: "",
  display_start_date: null,
};

const Banner = () => {
  const [filterValues, setFilterValues] = useState({});
  const setNotify = useNotifyContext();
  const [downloadId, setDownloadId] = useState([]);
  const styles = {
    iconButton: {
      padding: 0, 
    },
  };
  const actions = ["edit", "delete","download"];


const downloadLedger = (id) => {


  eightAxios.get(BANNER_URL + "export/?id=" + id + "&email=" + JSON.parse(localStorage.getItem('email')))
  .then((response) => {

    setNotify({
      isOpen: true,
      message: response.data.message,
      type: "success",
    });
  })
  .catch((error) => {
    setNotify({
      isOpen: true,
      message: error.response.data.message,
      type: "error",
    });
  });
};
  const onFilterRequest = (values) => {
    let filterObj = {};
    for (const [key, value] of Object.entries(values)) {
      if (value !== null && value !== "") {
        filterObj[key] = value;
      }
    }
    setFilterValues(filterObj);
  };

  return (
    <>
      <Filter
        filterFields={filterFields}
        initialValues={filterInitialValues}
        onSubmit={onFilterRequest}
      />
      <Table
        proxyURL="banner/"
        model={model}
        actions={actions}
        exportUrl="url"
        filterValues={filterValues}
        noFilter
        isBannerDelete={isBannerDelete}
        downloadId={downloadId}


      />
    </>
  );
};
export default Banner;
